/**
 * Reschedule and the 10-hour move rule (section 6; decisions 22, 123), the client's copy of the server's
 * (functions liveLessons/requests.ts NOTICE_HOURS). Reschedule always shows on a booked lesson ahead; inside
 * the 10 hours the player's sheet says so instead of offering times. DEV ONLY: LIVE_DEV_ANY_TIME lifts the
 * rule, as the server does. The coach's request is a proposal (98) and has no such rule.
 */
export const MOVE_NOTICE_HOURS = 10;

/** A booked lesson still ahead: Reschedule shows on it. */
export function reschedulable(b: { status: string; scheduledStartAt: string }, nowMs: number): boolean {
  return b.status === 'confirmed' && nowMs < Date.parse(b.scheduledStartAt);
}

/** Inside the 10 hours, the switch off: the player's sheet holds the "Too close to move" note. */
export function tooCloseToMove(p: { startAt: string; nowMs: number; devAnyTime: boolean }): boolean {
  return !p.devAnyTime && Date.parse(p.startAt) - p.nowMs < MOVE_NOTICE_HOURS * 3_600_000;
}

export const TOO_CLOSE_TITLE = 'Too close to move';
export const TOO_CLOSE_LINE = 'The lesson is less than 10 hours away, so it can\'t be moved now.';
